export enum DTableBody {
  ASSIGNMENT_OBJECT_ITEM = 'AssignmentObjectItem',
  ASSIGNMENT_OBJECT_SINGLE_ITEM = 'AssignmentObjectSingleItem',
  ASSIGNMENT_OBJECT_TURMA = 'AssignmentObjectTurma',
  DELIVERY_GRADE = 'DeliveryGrade',
  NO_DATA = 'NoData',
  SPINNER = 'Spinner',
  TURMAS = 'Turmas',
}
